import React from 'react';

export default function WhyUsSection() {
  return (
    <div className='why_us-section centered-content'>
      <h1 className='medium-text'>
        A <span className='target-text'>Comprehensive </span> Platform
      </h1>
      <p className='para-text font-18 roman-text'>
        Upgrade your behavioral health practice with a comprehensive platform that helps you get
        organized and engage better with more clients effectively.
      </p>
    </div>
  );
}
